'use client';

import { faWallet } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { HeaderOpenPaymentsBadge } from './header-open-payments-badge.component';

import { OpenPaymentsNoticePopover } from '@/app/(main)/_components/open-payments-notice/open-payments-notice-popover.component';
import { IconButtonLink } from '@/components/ui/icon-button/icon-button.component';
import { useOpenPaymentsAvailability } from '@/hooks/use-open-payments-availability.hook';
import { useOpenPayments } from '@/hooks/use-open-payments.hook';
import { OpenPaymentsOrigin } from '@/types/enums/analytics/open-payments/open-payments-analytics.enum';
import { buildOpenPaymentsLink } from '@/utils/consts/open-payments.consts';
import { pluralize } from '@/utils/pluralize.util';

function getOpenPaymentsLabel(count: number): string {
  return `Pagamentos em aberto, ${pluralize(count, 'pedido', 'pedidos')}`;
}

export function HeaderOpenPaymentsButton() {
  const { isAvailable } = useOpenPaymentsAvailability();
  const { count, hasPayments } = useOpenPayments();

  if (!isAvailable || !hasPayments) {
    return null;
  }

  return (
    <div className="flex items-start">
      <div className="relative">
        <IconButtonLink
          icon={faWallet}
          label={getOpenPaymentsLabel(count)}
          href={buildOpenPaymentsLink(OpenPaymentsOrigin.HEADER)}
          data-testid={DataTestIdEnum.OPEN_PAYMENTS_HEADER_BUTTON}
        />

        <OpenPaymentsNoticePopover />
      </div>

      <HeaderOpenPaymentsBadge count={count} />
    </div>
  );
}
